"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highestOwnedEditionAcrossAllHubsSelector = exports.highestOwnedEditionInHubSelector = exports.highestOwnedMerchIdInHubSelector = exports.ownsProductOrHigherSelector = exports.hasHigherTieredProductSelector = exports.ownsProductSelector = exports.parcelsSelector = exports.hasParcelSelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutable = require("immutable");

var _underscore = require("underscore");

var _isProductOwnedAdapter = _interopRequireDefault(require("self-service-api/adapters/isProductOwnedAdapter"));

var _hasHigherTieredProductAdapter = _interopRequireDefault(require("self-service-api/adapters/hasHigherTieredProductAdapter"));

var _validators = require("self-service-api/core/validators");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Editions = require("self-service-api/constants/Editions");

var _reselect = require("reselect");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var isActiveParcel = function isActiveParcel(parcel) {
  return parcel.quantity !== 0;
};

var allParcelsSelector = function allParcelsSelector(state) {
  return state.parcels;
};

var hasParcelSelector = function hasParcelSelector(_ref, parcelsToCheck) {
  var parcels = _ref.parcels;
  var parcelNames = parcels.map(function (parcel) {
    return parcel.parcelName;
  });
  return (0, _underscore.intersection)(parcelNames, parcelsToCheck).length > 0;
};

exports.hasParcelSelector = hasParcelSelector;
var parcelsSelector = (0, _reselect.createSelector)(allParcelsSelector, function (allParcels) {
  return allParcels && allParcels.filter(isActiveParcel);
});
exports.parcelsSelector = parcelsSelector;

var ownsProductSelector = function ownsProductSelector(state, merchandiseId) {
  if (!merchandiseId) return false;
  var merchandiseIdsTreatedAsOwned = state.merchandiseIdsTreatedAsOwned;
  var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var parcels = parcelsSelector(state);
  (0, _validators.validateMerchandiseId)(merchandiseId);
  if (!merchandiseMap) return false;
  return (0, _isProductOwnedAdapter.default)({
    merchandiseMap: merchandiseMap,
    parcels: parcels,
    merchandiseId: merchandiseId,
    merchandiseIdsTreatedAsOwned: merchandiseIdsTreatedAsOwned
  });
};

exports.ownsProductSelector = ownsProductSelector;

var hasHigherTieredProductSelector = function hasHigherTieredProductSelector(state, merchandiseId) {
  if (!merchandiseId) return false;
  var merchandiseIdsTreatedAsOwned = state.merchandiseIdsTreatedAsOwned;
  var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var parcels = parcelsSelector(state);
  (0, _validators.validateMerchandiseId)(merchandiseId);
  if (!merchandiseMap) return false;
  return (0, _hasHigherTieredProductAdapter.default)({
    merchandiseMap: merchandiseMap,
    parcels: parcels,
    merchandiseId: merchandiseId,
    merchandiseIdsTreatedAsOwned: merchandiseIdsTreatedAsOwned
  });
};

exports.hasHigherTieredProductSelector = hasHigherTieredProductSelector;

var ownsProductOrHigherSelector = function ownsProductOrHigherSelector(state, merchandiseId) {
  return ownsProductSelector(state, merchandiseId) || hasHigherTieredProductSelector(state, merchandiseId);
};

exports.ownsProductOrHigherSelector = ownsProductOrHigherSelector;

var highestOwnedMerchIdInHubSelector = function highestOwnedMerchIdInHubSelector(state, hub) {
  var useMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state) && hub === _Hubs.default.HUB_MARKETING;

  var highlightedMerchInHub = useMCBeta ? [].concat((0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch), (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerchMCBeta)) : _HubMap.default[hub].highlightedPaidMerch;
  var highestPaidMerchIdOwned = highlightedMerchInHub.find(function (merchId) {
    if (ownsProductSelector(state, merchId) && !hasHigherTieredProductSelector(state, merchId)) {
      return merchId;
    }

    return null;
  });
  var highlightedFreeMerchId = _HubMap.default[hub].highlightedFreeMerch;
  return highestPaidMerchIdOwned || highlightedFreeMerchId;
};

exports.highestOwnedMerchIdInHubSelector = highestOwnedMerchIdInHubSelector;

var highestOwnedEditionInHubSelector = function highestOwnedEditionInHubSelector(state, hub) {
  var highestOwnedMerchId = highestOwnedMerchIdInHubSelector(state, hub);
  var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);

  if (highestOwnedMerchId) {
    var edition = merchandiseMap[highestOwnedMerchId].edition;
    return edition !== null ? edition : _Editions.FREE;
  }

  return null;
};

exports.highestOwnedEditionInHubSelector = highestOwnedEditionInHubSelector;

var highestOwnedEditionAcrossAllHubsSelector = function highestOwnedEditionAcrossAllHubsSelector(state) {
  var _OrderedMap;

  var editionOwnershipOrderedMap = (0, _immutable.OrderedMap)((_OrderedMap = {}, (0, _defineProperty2.default)(_OrderedMap, _Editions.ENTERPRISE, false), (0, _defineProperty2.default)(_OrderedMap, _Editions.PROFESSIONAL, false), (0, _defineProperty2.default)(_OrderedMap, _Editions.STARTER, false), (0, _defineProperty2.default)(_OrderedMap, _Editions.FREE, true), _OrderedMap)).asMutable();
  [_Hubs.default.HUB_CMS, _Hubs.default.HUB_MARKETING, _Hubs.default.HUB_SALES, _Hubs.default.HUB_SERVICE].forEach(function (hub) {
    var edition = highestOwnedEditionInHubSelector(state, hub);
    editionOwnershipOrderedMap.set(edition, true);
  });
  return editionOwnershipOrderedMap.findKey(function (ownsEdition) {
    return ownsEdition;
  });
};

exports.highestOwnedEditionAcrossAllHubsSelector = highestOwnedEditionAcrossAllHubsSelector;